/* Keyboard picker tabs: no product counts, fit on phones, drag/swipe-to-scroll with a mouse on laptop/PC. Price row reads on one line: 'You pay $X  You save $Y'. */
(function () {
  if (document.getElementById('ftbn-tabs-extra')) return;
  var s = document.createElement('style');
  s.id = 'ftbn-tabs-extra';
  s.textContent = '.ftbn .ftbn__tab small{display:none}.ftbn .ftbn__tabs{cursor:grab;-webkit-user-select:none;user-select:none;overscroll-behavior-x:contain}.ftbn .ftbn__tabs.is-drag{cursor:grabbing}.ftbn .ftbn__tabs.is-drag .ftbn__tab{pointer-events:none}@media(max-width:520px){.ftbn .ftbn__tabs{gap:6px}.ftbn .ftbn__tab{padding:9px 13px;font-size:.82rem}}' +
    '.ftbn .ftbn__price{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:flex-start;gap:6px 14px}' +
    '.ftbn .ftbn__price > div:first-child{display:flex;align-items:baseline;gap:7px}' +
    '.ftbn .ftbn__price-lab{font-size:1.15rem;font-weight:800;letter-spacing:0;text-transform:none;color:#111}' +
    '.ftbn .ftbn__total{font-size:1.15rem;font-weight:800;line-height:1.2}' +
    '.ftbn .ftbn__save{display:inline;padding:0;border:0;border-radius:0;background:none;font-size:.9rem;font-weight:800;line-height:1.2;color:#E62129;white-space:nowrap}';
  document.head.appendChild(s);

  var el = null, startX = 0, startLeft = 0, moved = false, id = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    var t = e.target.closest && e.target.closest('.ftbn__tabs');
    if (!t || t.scrollWidth <= t.clientWidth) return;
    el = t; startX = e.clientX; startLeft = t.scrollLeft; moved = false; id = e.pointerId;
  });
  document.addEventListener('pointermove', function (e) {
    if (!el || e.pointerId !== id) return;
    var dx = e.clientX - startX;
    if (!moved && Math.abs(dx) > 4) { moved = true; el.classList.add('is-drag'); }
    if (moved) { el.scrollLeft = startLeft - dx; e.preventDefault(); }
  }, { passive: false });
  function end(e) {
    if (!el || e.pointerId !== id) return;
    var t = el; el = null;
    setTimeout(function () { t.classList.remove('is-drag'); }, 0);
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('wheel', function (e) {
    var t = e.target.closest && e.target.closest('.ftbn__tabs');
    if (!t || t.scrollWidth <= t.clientWidth || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    t.scrollLeft += e.deltaY;
    e.preventDefault();
  }, { passive: false });
})();
